var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolunteerOpportunities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Untitled design (15) 1",
    clipPath: "url(#clip0_5267_40362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5267_40362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 25,
    width: 24,
    height: 37
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "da3fdf2aa9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.0498 25.4863H28.2081V61.3613H5.0498V25.4863Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5267_40362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.3756 47.5878L17.8333 37.7398C17.4505 37.298 16.9055 37.0255 16.3091 36.9812C15.7199 36.9444 15.1455 37.1432 14.7036 37.5336C13.9526 38.2039 13.7464 39.2867 14.2029 40.1852L14.4385 40.6567C15.7347 43.2052 17.2737 45.6653 18.997 47.9636L20.4843 49.9522C20.72 50.269 20.8231 50.652 20.7642 51.0498C20.7054 51.44 20.5066 51.7864 20.1898 52.022C19.8731 52.2577 19.4829 52.3534 19.0927 52.3019C18.7023 52.2503 18.3563 52.0366 18.1278 51.7273L16.6405 49.746C14.8215 47.3153 13.194 44.7152 11.8169 42.0119L11.5813 41.5406C10.5136 39.4486 10.9923 36.9002 12.7449 35.3459C12.8775 35.2282 13.0172 35.1177 13.1572 35.0146L10.0497 27.1479C9.68888 26.242 8.81255 25.5939 7.84773 25.5202C7.11135 25.4612 6.41181 25.7116 5.87424 26.2125C5.33667 26.7207 5.04956 27.4058 5.05677 28.1424L5.39553 48.4717C5.42496 50.3795 6.18356 52.1766 7.51638 53.532L15.1971 61.3544H28.1871L27.9441 51.4768C27.8632 50.0405 27.3034 48.6633 26.3756 47.5878Z",
    fill: "url(#paint0_linear_5267_40362)"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.3525 69.2421C15.3525 69.927 15.9121 70.4868 16.5971 70.4868H26.9434C27.6284 70.4868 28.188 69.9344 28.188 69.2421V64.1523H15.3525V69.2421Z",
    fill: "#193861"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M65.1029 26.2049C64.5653 25.6967 63.8658 25.4537 63.1294 25.5125C62.1648 25.5862 61.2885 26.2343 60.9277 27.1403L57.82 35.0069C57.9599 35.1026 58.0999 35.2205 58.2324 35.3384C59.9851 36.8999 60.4636 39.4484 59.3959 41.5329L59.1602 42.0042C57.7831 44.7075 56.163 47.3076 54.3369 49.7383L52.8493 51.7196C52.6137 52.0364 52.2675 52.2426 51.8847 52.2942C51.4943 52.3531 51.1041 52.25 50.7873 52.0143C50.4708 51.7787 50.2646 51.4325 50.2129 51.0421C50.1541 50.6517 50.2572 50.2613 50.4928 49.9446L51.9804 47.9559C53.7036 45.6503 55.2352 43.1975 56.5386 40.649L56.7743 40.1777C57.231 39.2864 57.0247 38.1962 56.2735 37.5259C55.8317 37.1283 55.2573 36.9367 54.6682 36.9736C54.0644 37.0178 53.5268 37.2903 53.1438 37.7322L44.6016 47.5875C43.6664 48.663 43.1142 50.0403 43.0331 51.4694L42.79 61.3467H55.7802L63.4608 53.5243C64.7938 52.1691 65.5522 50.3718 65.5816 48.464L65.9204 28.1347C65.9352 27.3981 65.6405 26.7132 65.1029 26.2049Z",
    fill: "url(#paint1_linear_5267_40362)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M42.7832 69.2421C42.7832 69.927 43.3428 70.4868 44.0277 70.4868H54.3667C55.0516 70.4868 55.6112 69.9344 55.6112 69.2421V64.1523H42.7832V69.2421Z",
    fill: "#193861"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M49.7049 18.1468C46.0744 15.1488 40.6619 15.6866 37.3334 19.0159L35.4408 20.9015L33.2758 18.736C29.5495 15.0089 23.3639 15.2225 19.9249 19.3915C16.9277 23.0229 17.4653 28.4366 20.7938 31.7659L33.6366 44.6117C34.6307 45.6062 36.236 45.6062 37.2302 44.6117L50.3602 31.5008C54.0937 27.7737 53.8729 21.5866 49.7049 18.1468Z",
    fill: "url(#paint2_linear_5267_40362)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M35.4778 10.2281C36.84 10.2281 37.9448 9.12313 37.9448 7.7605V2.98028C37.9448 1.62486 36.84 0.512695 35.4778 0.512695C34.1227 0.512695 33.0107 1.61746 33.0107 2.98028V7.7605C33.0181 9.11591 34.1227 10.2281 35.4778 10.2281Z",
    fill: "#FDB841"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M24.999 11.2445C25.4408 12.0031 26.2581 12.4745 27.1344 12.4745C27.5689 12.4745 27.9887 12.3566 28.3643 12.143C28.9313 11.8116 29.3438 11.2813 29.5132 10.6478C29.6825 10.0144 29.594 9.35147 29.2701 8.77687L26.8768 4.63733C26.5454 4.07013 26.0152 3.6577 25.382 3.48832C24.7485 3.31894 24.0858 3.40724 23.5114 3.73878C22.9444 4.07013 22.532 4.60049 22.3626 5.23395C22.1932 5.87482 22.2817 6.53772 22.6056 7.10491L24.999 11.2445Z",
    fill: "#FDB841"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M42.606 12.1209C42.9816 12.3345 43.4087 12.4522 43.8357 12.4522C44.7121 12.4522 45.5369 11.9809 45.9714 11.2221L48.3647 7.08277C48.6961 6.50817 48.7844 5.84527 48.6076 5.21181C48.4382 4.57834 48.026 4.04799 47.4588 3.71664C46.2807 3.03152 44.7709 3.44396 44.0936 4.61518L41.7003 8.75472C41.0228 9.92576 41.4278 11.4357 42.606 12.1209Z",
    fill: "#FDB841"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5267_40362",
    x1: 16.6219,
    y1: 25.5117,
    x2: 16.6219,
    y2: 61.3544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#348BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#193861"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5267_40362",
    x1: 54.3555,
    y1: 25.5039,
    x2: 54.3555,
    y2: 61.3467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#348BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#193861"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5267_40362",
    x1: 35.4814,
    y1: 16.0937,
    x2: 35.4814,
    y2: 45.3576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C73737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C1717"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5267_40362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolunteerOpportunities);
export default __webpack_public_path__ + "static/media/volunteer-opportunities.de0766452d55a04532fd3345844c3094.svg";
export { ForwardRef as ReactComponent };